module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Shifting Views")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("By Meg Harding")]), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("A Carlisles novel")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Successful fashion model Denver Carlisle is finally living on his own. He’s got a new apartment, a neighbor who has a problem shutting his blinds, and a local bakery with an owner who makes his knees weak. It’s raining men, and Denver hasn’t gotten any in a long time. Going out on a limb, he asks Ethan Monahan out and resorts to a little exhibitionism for his neighbor. Only to be turned down by both. That’s a first.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ethan Monahan runs his own bakery and has a new neighbor who walks around naked. The latter is a little too distracting. When his naked neighbor turns out to be none other than model Denver Carlisle—and the customer who asked him out—Ethan tries to make amends. In a purely friendly way.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Friendship leads to more, and both men find themselves in over their heads with emotions and compromises. Denver has trust issues that could span the Sahara, and Ethan is a product of the foster system with a chip on his shoulder and a serious wariness of those with money. There’s only one way to reconcile their issues: work together.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34a0e764","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0001.vue
// module id = 57
// module chunks = 0